import { ObjectKeys } from './index'

export interface ICoordinates {
  lat: number;
  lng: number;
}

export interface IAppointment {
  id: number,
  start: string,
  end: string,
  lat: number,
  lng: number
}

export interface IStatistics extends ObjectKeys {
  average_drive_miles: number,
  average_drive_time_minutes: number,
  total_appointments: number,
  total_drive_miles: number,
  total_drive_time_minutes: number,
  total_service_time_minutes: number,
}

export interface IFleetRoute {
  id: number,
  service_pro_id: number,
  service_pro_name: string,
  external_id: string,
  avatar?: string,
  avatar_placement?: ICoordinates,
  appointments: IAppointment[],
  area: ICoordinates[],
  statistics: IStatistics,
  geometry: string | null,
  actual_stats: {
    at_risk: boolean,
    completion_percentage: number,
  },
  tracking_data?: {
    driver_location: ICoordinates,
    vehicle_location: ICoordinates,
    vehicle_speed: number
  }
}

export interface ISummary extends ObjectKeys {
  total_routes: number,
  total_appointments: number,
  total_drive_time_minutes: number,
  total_drive_miles: number,
  total_service_time_minutes: number,
  appointments_per_gallon: number,
  total_routes_actual: number,
  total_appointments_actual: number,
  total_drive_time_minutes_actual: number,
  total_drive_miles_actual: number,
  total_service_time_minutes_actual: number,
  appointments_per_gallon_actual: number
}

export interface IFleetRouteResult {
  routes: IFleetRoute[],
  summary: ISummary
}

export interface IMetaData {
  success: boolean
}

export interface IFleetRoutes {
  _metadata: IMetaData
  result: IFleetRouteResult
}

export enum EMapType {
  SATELLITE,
  TERRAIN,
  TRAFFIC,
}
